import React,{useState} from 'react';

import Alarmas from './Alarmas';

function VerAlarmas(){
    /*Sirve para que las llamadas no se acumulen al cambiar de ventana  */
    var [code, setCode] = useState(null);
    if(code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }
    window.addEventListener("orientationchange", function(){
        window.location.reload();
      });

    return (
        <div>
            <Alarmas code={code}/>
        </div>
        
    );
};

export default VerAlarmas;